import { Comment } from './comment';
import { CoordinatorService } from './coordinator.service';

export class ScriptComment {
    #coords: CoordinatorService;
    #_comment: Comment;

    constructor(coords: CoordinatorService, comment: Comment) {
        this.#coords = coords;
        this.#_comment = comment;
    }

    get id() {
        return this.#_comment.id;
    }

    json() {
        return this.#_comment.save();
    }

    log(prefix = 'Comment') {
        console.log(`${prefix}: ${this.json()}`);
        return this;
    }

    display = this.log;
}
